// extracted by mini-css-extract-plugin
export default {"icon":"RelationalFlagGrid_icon__sz72o","column":"RelationalFlagGrid_column__2adVU"};